'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import classnames from 'classnames';
import { nanoid } from 'nanoid';
export const Star = (_a) => {
    var { className, variant, id, size } = _a, other = __rest(_a, ["className", "variant", "id", "size"]);
    const idVar = React.useRef(id || nanoid());
    const componentClassName = classnames('sparky-c-star', className, {
        'sparky-c-star--half': variant === 'half',
        'sparky-c-star--full': variant === 'full',
        'sparky-c-star--lg': size === 'lg',
        'sparky-c-star--md': size === 'md',
        'sparky-c-star--sm': size === 'sm',
    });
    return (_jsxs("svg", Object.assign({ className: componentClassName, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, other, { children: [_jsxs("linearGradient", Object.assign({ className: "sparky-c-star__gradient", id: idVar.current, x1: "0", x2: "100%", y1: "0", y2: "0%" }, { children: [_jsx("stop", { offset: "50%", stopColor: "var(--star-color-stop-1)" }), _jsx("stop", { offset: "50%", stopColor: "var(--star-color-stop-2)" })] })), _jsx("path", { fill: idVar.current && `url(#${idVar.current})`, d: "M10.98,3.56c0.38-0.57,1.14-0.72,1.71-0.35\n  c0.14,0.09,0.26,0.21,0.35,0.35l2.58,3.91c0.18,0.27,0.45,0.45,0.76,0.52l4.66,1.05c0.66,0.15,1.08,0.8,0.93,1.46\n  c-0.05,0.21-0.15,0.4-0.29,0.56l-3.02,3.3c-0.23,0.25-0.35,0.59-0.32,0.93l0.37,4.4c0.05,0.68-0.45,1.27-1.13,1.32\n  c-0.19,0.02-0.37-0.01-0.55-0.08l-4.59-1.76c-0.29-0.11-0.6-0.11-0.89,0l-4.58,1.75c-0.64,0.25-1.35-0.07-1.6-0.7\n  c-0.07-0.17-0.09-0.36-0.08-0.54l0.37-4.4c0.03-0.34-0.09-0.68-0.32-0.93l-3.03-3.3c-0.46-0.5-0.42-1.28,0.08-1.73\n  c0.16-0.14,0.35-0.24,0.56-0.29l4.67-1.05C7.95,7.91,8.22,7.73,8.4,7.46L10.98,3.56z" })] })));
};
//# sourceMappingURL=Star.js.map